"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalization = exports.setTranslation = void 0;
let translation;
let _isProduction;
const reg = /(\%.*?%)/g;
const setTranslation = (t, isProduction) => {
    _isProduction = isProduction ? isProduction : false;
    translation = t.translations;
    return translation;
};
exports.setTranslation = setTranslation;
const getLocalization = (localized, params) => {
    if (translation && translation[localized]) {
        if (params && params.length > 0) {
            const matches = translation[localized].match(reg);
            if (matches !== null && matches.length > 0) {
                const parametrized = matches.reduce((str, tran, i) => {
                    return str.replace(tran, params[i]);
                }, translation[localized]);
                if (reg.test(parametrized) && !_isProduction) {
                    throw new Error(`Translation parameter not set for ${parametrized}`);
                }
                return parametrized;
            }
        }
        return translation[localized];
    }
    return localized;
};
exports.getLocalization = getLocalization;
//# sourceMappingURL=translation.js.map